// Centralized analytics event tracking
// GA4 must be loaded via gtag.js in index.html

const isDev = process.env.NODE_ENV === 'development';

function gtag(...args) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...args);
  } else if (isDev) {
    console.debug('[Analytics]', ...args);
  }
}

// Page view (called on route change)
export function trackPageView(path, title) {
  gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
  });
}

// Booking events
export function trackBookingStarted(type, itemName, price) {
  gtag('event', 'begin_checkout', {
    currency: 'INR',
    value: price,
    items: [{ item_name: itemName, item_category: type }],
  });
}

export function trackBookingCompleted(type, itemName, price, bookingId) {
  gtag('event', 'purchase', {
    transaction_id: bookingId,
    currency: 'INR',
    value: price,
    items: [{ item_name: itemName, item_category: type }],
  });
}

// Search
export function trackSearch(query, resultsCount) {
  gtag('event', 'search', { search_term: query, results_count: resultsCount });
}

// Darshan / Puja engagement
export function trackDarshanClick(source) {
  gtag('event', 'darshan_click', { source });
}

export function trackPujaView(pujaName, pujaId) {
  gtag('event', 'view_item', {
    items: [{ item_id: pujaId, item_name: pujaName, item_category: 'epuja' }],
  });
}

export function trackHotelView(hotelName, hotelId, price) {
  gtag('event', 'view_item', {
    items: [{ item_id: hotelId, item_name: hotelName, item_category: 'hotel', price }],
  });
}

// Auth events
export function trackSignUp(method = 'email') {
  gtag('event', 'sign_up', { method });
}

export function trackLogin(method = 'email') {
  gtag('event', 'login', { method });
}

// Language switch
export function trackLanguageSwitch(language) {
  gtag('event', 'language_switch', { language });
}

// Theme toggle
export function trackThemeToggle(theme) {
  gtag('event', 'theme_toggle', { theme });
}

// Outbound link (e.g. Sugam Darshan external site)
export function trackOutboundLink(url, label) {
  gtag('event', 'click', {
    event_category: 'outbound',
    event_label: label || url,
    transport_type: 'beacon',
  });
}
